"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    admissionResultAdded: () => 'Admission result added',
    admissionResultNotAdded: () => 'Failed to add admission result',
    admissionResultUpdated: () => 'Admission result has been updated',
    admissionResultNotUpdated: () => 'Failed to update admission result',
    admissionResultNotFetched: () => 'Failed to fetch user admission result',
    admissionResultDeleted: () => 'Admission result has been deleted',
    admissionResultNotDeleted: () => 'Failed to delete admission result',
    allocationAccepted: () => 'Allocation accepted! Check your email for more details',
    allocationNotAccepted: () => 'Failed to accept student',
    allocationCancelled: () => 'You have cancelled an allocation request',
    allocationDeclined: () => 'Allocation declined',
    allocationNotDeclined: () => 'Failed to decline student',
    allocationRemoved: (tutor, student) => `${tutor || 'The tutor'} is no longer allocated to ${student || 'the student'}`,
    allocationNotRemoved: () => 'Failed to remove contract',
    allocationRequested: () => 'Request sent! Remember to check this status within 24 hours to ensure the allocation is successful',
    billingInfoNotFetched: (user) => `Failed to fetch ${user || 'user'} billing info`,
    billingCountryUpdated: () => 'Successfully updated billing country',
    billingCountryNotUpdated: (user) => `Failed to edit ${user || 'user'} billing country info`,
    billingPayRatesUpdated: () => 'Successfully updated user subject rates',
    billingPayRatesNotUpdated: (user) => `Failed to edit ${user || 'user'} subject rates`,
    bookingCancelled: () => 'Your booking has been cancelled',
    bookingConfirmed: () => 'Your booking is confirmed',
    bookingUnscheduled: () => 'Your booking is unscheduled',
    bookingCreated: () => 'Booking request sent',
    bookingDeclined: () => 'Booking request declined',
    bookingRescheduled: (user) => `You have suggested a new time. ${user || 'The other party'} will need to confirm this new time`,
    bookingUpdated: () => 'Your booking request has been updated',
    commentFileDeleted: () => 'File was successfully deleted',
    commentFileNotDeleted: () => 'Error deleting a file',
    commentFileNotRetrieved: () => 'Failed to retrieve shared files. Please contact support',
    commentFileNotUploaded: () => 'Failed to upload file',
    commentNotDeleted: () => 'Error deleting comment',
    commentNotEdited: () => 'Error editing comment',
    commentNotSent: () => 'Error posting comment',
    commentReplyNotSent: () => 'Error posting reply',
    feedbackNoSession: () => "Thanks for your feedback. We've removed this session",
    feedbackSent: () => 'Thanks for your feedback!',
    feedbackNotSent: () => 'Failed to submit feedback',
    feedbackSessionReported: () => 'Thanks for completing your session report! Once your student has confirmed, these hours will be logged for your next invoice',
    feedbackSessionNotReported: () => 'Failed to submit session report',
    invoiceDeleted: () => 'Invoice has been deleted',
    invoiceNotDeleted: () => 'Failed to delete invoice',
    invoiceNotFetched: () => 'Failed to retrieve invoice',
    invoicePaid: () => 'Invoice marked as paid',
    invoiceNotPaid: () => 'Failed to mark invoice as paid',
    invoiceSubmitted: () => 'Your invoice has been submitted',
    invoiceNotSubmitted: () => 'Failed to submit invoice',
    lessonEdited: () => 'Session detail was successfully edited',
    lessonNotEdited: () => 'Failed to edit session detail',
    lessonNavigationFailed: () => 'Could not navigate to session',
    packageAdded: (student) => `A package for ${student || 'the student'} has been created`,
    packageEdited: () => 'Package was successfully edited',
    packageSubjectCreated: (subject, student) => `${subject || 'Subject'} has been added to ${student || 'the'} package`,
    packageSubjectDeleted: () => 'Subject was successfully deleted',
    packageSubjectUpdated: () => 'Subject was successfully updated',
    passwordReset: (emails) => `We've sent an email to ${emails || 'your registered email address'}. Follow the instructions to reset your password`,
    roadmapCreated: () => 'A new roadmap was created',
    roadmapDeleted: () => 'Roadmap has been deleted',
    roadmapPublished: () => 'Roadmap has been published',
    roadmapMissionCreated: () => 'A new mission was created',
    roadmapMissionDeleted: () => 'Mission has been deleted',
    roadmapMissionUpdated: () => 'Mission has been updated',
    roadmapDeadlineCreated: () => 'A new deadline was created',
    roadmapDeadlineDeleted: () => 'Deadline has been deleted',
    roadmapDeadlineUpdated: () => 'Deadline has been updated',
    roadmapCategoryCreated: () => 'A new category was created',
    roadmapCategoryDeleted: () => 'Category has been deleted',
    roadmapCategoryUpdated: () => 'Category has been updated',
    roadmapTemplateCreated: () => 'A new template was created',
    roadmapTemplateDeleted: () => 'Template has been deleted',
    roadmapTemplateLoaded: () => 'A new roadmap was created from the template',
    roadmapTaskAdded: () => 'A new task has been added',
    roadmapTaskCompleted: () => 'Task was marked completed',
    userAvailibilityUpdated: () => 'Unavailable times was successfully saved',
    userAvailibilityNotUpdated: () => 'Failed to save unavailable times',
    userEducationUpdated: () => 'Successfully updated education',
    userEducationNotUpdated: () => 'Failed to update education',
    userExpertiseUpdated: () => 'Successfully updated expertise',
    userExpertiseNotUpdated: () => 'Failed to update expertise',
    userFileMissing: () => 'Upload failed. Please select a file',
    userFileNotUploaded: () => 'Failed to upload file',
    userGuardianUpdated: () => 'Updated guardian section',
    userGuardianNotUpdated: () => 'Failed to update profile',
    userInterestUpdated: () => 'Successfully updated interests',
    userInterestNotUpdated: () => 'Failed to update interests',
    userInvitationSent: () => 'User will receive an email with invitation details',
    userInvitationNotSent: () => 'Failed to sent invite to user. Please contact support or try again later',
    userOnboarded: () => 'You have successfully added a new user. They will receive an email to set up their account',
    userNotOnboarded: () => 'Failed to send invite to user. Please contact support or try again later',
    userNotFetched: () => 'Failed to retrieve users',
    userProfileUpdated: () => 'Your profile has been updated',
    userProfileNotUpdated: () => 'Failed to update user profile',
    userProfileImageUploaded: () => 'Profile picture uploaded successfully',
    userRelationshipUpdated: () => 'Successfully updated role assignment in Team',
    userRelationshipNotUpdated: () => 'Failed to update role assignment in Team',
    userRoleAdded: () => 'Successfully assigned new roles to user',
    userRoleNotAdded: () => 'Failed to assign user role',
    userStatusUpdated: (action) => `The user's account has been ${action || 'updated'}`,
    userStatusNotUpdated: (action) => `Failed to set the user's status as ${action}`,
    userStudentsNotFetched: () => 'Unable to fetch students',
    userSubjectAdded: (tutor) => `${tutor || 'Tutor'}'s subjects have been updated`,
    userSubjectNotUpdated: () => 'Failed to update subject',
    userSubjectNotAssigned: () => "The tutor's subjects could not be assigned",
    userUnavailable: () => 'You have updated your unavailable times',
    zendeskLoginUrlNotFetched: () => 'Failed to fetch zendesk login url',
    friendAcceptSucceed: () => 'You two are friends now! Start messaging each other!',
    friendAcceptFailed: () => 'There’s been a problem of accepting the request, please try again.',
    friendBlockSucceed: () => 'You are no longer friends with this person, and you can not message each other any more.',
    friendBlockFailed: () => 'There’s been a problem of unfriending this person, please try again.',
    friendIgnoreSucceed: () => 'The friend request has been deleted. You may add friend again if you change your mind.',
    friendIgnoreFailed: () => 'There’s been a problem of deleting the request, please try again.',
};
//# sourceMappingURL=toasterMessages.js.map